import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';

import { server } from './constants';
@Injectable()
export class AddressesService {

  private httpAddress = server;

    httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    }

     constructor(private http:HttpClient) { }
      ngOnInit() {    }

  updateClientContact(body) {
    // update a contact on tblclientcontact
    return this.http.post(this.httpAddress + 'api/addresses/updatecontactclient/' + body.contactid, body, this.httpOptions)
      .toPromise()
      .then(result => result)
      .catch(err => console.log(err))
  }

  updateContact(body) {
    // update a contact on tblclientcontact
    return this.http.post(this.httpAddress + 'api/addresses/updatecontact/' + body.contactid, body, this.httpOptions)
      .toPromise()
      .then(result => result)
      .catch(err => console.log(err))
  }

  getAltAddresses(clientId):Promise<any>{
      // get the clients from tblqbcust and return
      return this.http.get(this.httpAddress +'api/addresses/get/' + clientId)
      .toPromise()
      .then(clients => clients)
      .catch(err => console.log(err))
  };

  getAddressContacts(id):Promise<any> {
      return this.http.get(this.httpAddress + 'api/addresses/contacts/' + id,)
      .toPromise()
      .then(contacts => contacts)
      .catch(err => console.log(err))
  };

  getAddressContact(contactid):Promise<any> {
    // get a single address contact and return
    return this.http.get(this.httpAddress + 'api/addresses/contact/' + contactid,)
      .toPromise()
      .then(contact => contact)
      .catch(err => console.log(err))
  };

  onAddAddress(shipper, clientId):Promise<any> {
    return this.http.post(this.httpAddress + 'api/addresses/addalt/' + clientId, shipper, this.httpOptions)
      .toPromise()
      .then(newAddress => newAddress)
      .catch(err => console.log(err))
  };

  onAddClient(client):Promise<any> {
    console.log(client)
    return this.http.post(this.httpAddress + 'api/clientadd', client, this.httpOptions)
      .toPromise()
      .then(newClient => newClient)
      .catch(err => console.log(err))
  };

  addAddressContact(contact, altaddressid): Promise<any> {
    return this.http.post(this.httpAddress + 'api/addresses/newcontact/' + altaddressid, contact, this.httpOptions)
      .toPromise()
      .then(result => result)
      .catch(err => console.log(err))
  };

  addClientContact(clientid, body) {
    // post new client contact to api/adresses/newclientcontact/:clientid

    return this.http.post(this.httpAddress + 'api/addresses/newcontactclient/' + clientid, body, this.httpOptions)
      .toPromise()
      .then(result => result)
      .catch(err => console.log(err))
  }


  getClientContacts(clientid) {
    return this.http.get(this.httpAddress + 'api/addresses/getclientcontacts/' + clientid )
      .toPromise()
      .then(contacts => contacts)
      .catch(err => console.log(err));
  }


}



// WEBPACK FOOTER //
// ./src/app/services/addresses.service.ts